import { resolveColorProperty } from '@gn-audio/jss-components';

import { StatProps } from 'components/Product/StatsSpot/statsSpotTypes';

export const Stat = ({ value, valueFontColor, description }: StatProps) => {
  const resolvedValueFontColor = resolveColorProperty(valueFontColor?.value);
  return (
    <>
      {!!value?.value && !!description?.value && (
        <div className="flex flex-col border-b xs:flex-row xs:gap-9">
          <div
            style={{ color: resolvedValueFontColor }}
            className="text-[4rem] leading-[5rem] md:text-[6rem] md:leading-[7rem]"
          >
            {value.value}
          </div>
          <p
            className="mb-3 text-left text-[1.5rem] xs:mb-6 md:text-[1.75rem]"
            dangerouslySetInnerHTML={{ __html: description.value }}
          />
        </div>
      )}
    </>
  );
};
